
// Returns a bootstrap color variant based on a status
export const getOrderStatusVariant = (status: string) => {
    switch (status.trim()) {
      case "Back Order":
        return "warning";
      case "Held Back Order":
        return "danger";
      case "Held Allocated":
        return "danger";
      case "Allocated":
        return "info";
      default:
        return "success";
    }
  };

  export const getClassNameWithTextForStockStatusBadge = (themeCodeToGetClassFor: string,textToGetClassNameFor: string) => {
    switch (themeCodeToGetClassFor.trim())
    {
      //Brockway
      case "sj5xkM6L":
        return getBrockwayClassNameWithText("Stock Badge",textToGetClassNameFor);
      //Valley
      case "vall41JU":
        return getValleyClassNameWithText("Stock Badge",textToGetClassNameFor);
      default:
        switch (textToGetClassNameFor.trim()) {
          case "Awaiting Stock":
            return "stock-badge-awaitingstock";
          case "Awaiting PO":
            return "stock-badge-onpurchase";
          case "Available":
            return "stock-badge-instock";
          case "Low Stock":
            return "stock-badge-lowstock";
         default:
            return "";
        }
    }
  }

  export const getClassNameWithText = (themeCodeToGetClassFor: string,textToGetClassNameFor: string) => {
    switch (themeCodeToGetClassFor.trim())
    {
      //Brockway
      case "sj5xkM6L":
        return getBrockwayClassNameWithText("",textToGetClassNameFor);
      //Valley
      case "vall41JU":
        return getValleyClassNameWithText("",textToGetClassNameFor);
      default:
        switch (textToGetClassNameFor.trim()) {
          case "Awaiting Stock":
            return "text-danger";
            case "Available":
              return "text-success";
         default:
            return "";
        }
    }
  }

  export const getBrockwayClassNameWithText = (typeToGetClassNameFor: string, textToGetClassNameFor: string) => {
    switch (typeToGetClassNameFor.trim())
    {
      case "Stock Badge":
        switch (textToGetClassNameFor.trim()) {
          case "Awaiting Stock":
            return "stock-badge-brockway-awaitingstock";
          case "Awaiting PO":
            return "stock-badge-brockway-onpurchase";
          case "Available":
            return "stock-badge-brockway-instock";
        default:
          return "";
      }
    default:
      switch (textToGetClassNameFor.trim()) {
        case "Awaiting Stock":
          return "text-warning-brockway";
          case "Available":
            return "text-success-brockway";
      default:
          return "";
      }
    }
  }

  export const getValleyClassNameWithText = (typeToGetClassNameFor: string,textToGetClassNameFor: string) => {
    switch (typeToGetClassNameFor.trim())
    {
      case "Stock Badge":
        switch (textToGetClassNameFor.trim()) {
          case "Awaiting Stock":
            return "stock-badge-valley-awaitingstock";
          case "Awaiting PO":
            return "stock-badge-valley-onpurchase";
          case "Available":
            return "stock-badge-valley-instock";
        default:
          return "";
      }
      default:
      switch (textToGetClassNameFor.trim()) {
        case "Awaiting Stock":
          return "text-warning-valley";
          case "Available":
            return "text-success-valley";
        case "Width Label Class":
          return "text-width-label-valley";
        case "Width Input Class":
          return "text-width-input-valley";
      default:
          return "";
      }
    }
  }
  
  export const getBadgeColourForTextBrockway = (status: string) => {
    switch (status.trim()) {
     
      case "Held Back Order":
        return getBrockwaysColourHex("red"); //their red colour
      case "Held Allocated":
        return getBrockwaysColourHex("red"); 
      case "Out of Stock":
        return getBrockwaysColourHex("red"); 
      //Doesn't seem to appear in their data but leaving in just in case
      case "Back Order":
          return getBrockwaysColourHex("brown");

      case "Cut":
        return getBrockwaysColourHex("green");
      case "Allocated":
        return getBrockwaysColourHex("green");
      case "Allocated Proforma":
          return getBrockwaysColourHex("green");
      case "Success":
            return getBrockwaysColourHex("green");
      default:
        return getBrockwaysColourHex("black");
    }
  };

  export const getBrockwaysColourHex = (colourToGetHexFor: string) => {
    switch (colourToGetHexFor) {
      case "red": 
        return "#D5A286";
      case "black": 
        return "#3A3B3E";
      case "green": 
        return "#B3B995"; 
      case "brown": 
        return "#94795D";
      case "greenyGrey": 
        return "#5E7461";  
      case "darkGreen": 
        return "#627569";
      default:
        return "B3B995"; //default black
    }
  } 

  export const getOrderStatusTextColorBrockway= (status: string) => {
    switch (status.trim()) {
     
      case "Held Back Order":
        return "white";
      case "Held Allocated":
        return "white";  
      case "Out of Stock":
        return "white";
      //Doesn't seem to appear in their data but leavign in just in case
      case "Back Order":
          return "black";
      case "Cut":
            return "white";
      case "Allocated":
            return "white";
      case "Allocated Proforma":
            return "white";
      case "Success":
              return "white";
      default:
        return "white";
    }
  };

  export const getFncsColourHex = (colourToGetHexFor: string) => {
    switch (colourToGetHexFor) {
      case "green": 
        return "#0BE7DF";  //Changed this to a blue colour
      case "amber": 
        return "#d5af17";  
      case "red": 
        return "#dc0d17";
      case "blue": 
        return "#65def1"; 
      case "hotPink": 
        return "#eb1e6f";
      case "darkBlue": 
        return "#132364";  
      case "skyBlue": 
        return "#65def1";
      case "grey": 
        return "#a3b6be";
      case "lighterGrey": 
        return "#e2e9ec";
      default:
        return "B3B995"; //default black
    }
  }
  export const getFranksColourHex = (colourToGetHexFor: string) => {
    switch (colourToGetHexFor) {
      case "green": 
        return "#c29a43";  //Changed this to a blue colour
      case "amber": 
        return "#d5af17";  
      case "red": 
        return "#dc0d17";
      case "blue": 
        return "#65def1"; 
      case "hotPink": 
        return "#eb1e6f";
      case "darkBlue": 
        return "#132364";  
      case "skyBlue": 
        return "#65def1";
      case "grey": 
        return "#a3b6be";
      case "lighterGrey": 
        return "#e2e9ec";
      default:
        return "B3B995"; //default black
    }
  }

  export const getBadgeColourForTextFnc = (status: string) => {
    switch (status.trim()) {
      case "Awaiting Despatch":
        return getFncsColourHex("hotPink"); //their red colour
      case "Back Order":
        return getFncsColourHex("amber"); //their red colour
      case "Cancelled":
        return "#dc0d17";
      case "Order Complete":
        return getFncsColourHex("skyBlue"); 
      case "Allocated":
        return getFncsColourHex("green");
      case "Held Allocated":
        return getFncsColourHex("red"); 

    //below not asked for by them so unlikely to make an appearance - but default to grey with white text now
      case "Held Back Order":
        return getFncsColourHex("red");
      case "Out of Stock":
        return getFncsColourHex("red"); 
      case "Cut":
        return getFncsColourHex("green");
      case "Allocated Proforma":
          return getFncsColourHex("green");
      case "Success":
            return getFncsColourHex("green");
      default:
        return getFncsColourHex("grey");
    }
  };

  export const getOrderStatusTextColorFnc= (status: string) => {
    switch (status.trim()) {
      case "Awaiting Despatch":
        return "white"; 
      case "Cancelled":
        return "white";
      case "Order Complete":
        return "white";  
      case "Allocated":
            return "white";
      case "Held Back Order":
        return "white";
      case "Held Allocated":
        return "white";  
      case "Out of Stock":
        return "white";
      case "Back Order":
          return "black";
      case "Cut":
            return "white";
      case "Allocated":
            return "white";
      case "Allocated Proforma":
            return "white";
      case "Success":
              return "black";
      default:
        return "white";
    }
  };



  export const getKellarsColourHex = (colourToGetHexFor: string) => {
    switch (colourToGetHexFor) {
      case "almostBlack": 
        return "#3a3b3e";  
      default:
        return "B3B995"; //default black
    }
  };

  export const getValleyColourHex = (colourToGetHexFor: string) => {
    switch (colourToGetHexFor) {
      case "clarnet": 
        return "#481210";  
      default:
        return "B3B995"; //default black
    }
  };